const de: Record<string, string> = {
  // --- Common / Shared ---
  "common.loading": "Laden...",
  "common.save": "Speichern",
  "common.saving": "Speichern...",
  "common.cancel": "Abbrechen",
  "common.delete": "Löschen",
  "common.edit": "Bearbeiten",
  "common.create": "Erstellen",
  "common.creating": "Erstellen...",
  "common.close": "Schließen",
  "common.copy": "Kopieren",
  "common.search": "Suchen...",
  "common.back": "Zurück",
  "common.next": "Weiter",
  "common.yes": "Ja",
  "common.no": "Nein",
  "common.active": "Aktiv",
  "common.inactive": "Inaktiv",
  "common.on": "An",
  "common.off": "Aus",
  "common.name": "Name",
  "common.email": "E-Mail",
  "common.domain": "Domain",
  "common.slug": "Slug",
  "common.role": "Rolle",
  "common.status": "Status",
  "common.actions": "Aktionen",
  "common.settings": "Einstellungen",
  "common.upload": "Hochladen",
  "common.uploading": "Hochladen...",
  "common.download": "Herunterladen",
  "common.remove": "Entfernen",
  "common.add": "Hinzufügen",
  "common.entries": "Einträge",
  "common.entry": "Eintrag",
  "common.fields": "Felder",
  "common.preview": "Vorschau",
  "common.noLogo": "Kein Logo",
  "common.noIcon": "Kein Icon",
  "common.noImage": "Kein Bild",
  "common.networkError": "Netzwerkfehler",
  "common.connectionError": "Verbindungsfehler. Server nicht erreichbar.",
  "common.errorOccurred": "Ein Fehler ist aufgetreten",
  "common.errorLoading": "Fehler beim Laden",
  "common.errorSaving": "Fehler beim Speichern",
  "common.errorDeleting": "Fehler beim Löschen",
  "common.errorUpdating": "Fehler beim Aktualisieren",
  "common.errorCreating": "Fehler beim Erstellen",
  "common.saved": "Gespeichert",
  "common.justNow": "gerade eben",
  "common.minutesAgo": "vor {n} Min.",
  "common.hoursAgo": "vor {n} Std.",
  "common.deleted": "Gelöscht",
  "common.admin": "Admin",
  "common.editor": "Editor",
  "common.password": "Passwort",
  "common.live": "Live",
  "common.draft": "Entwurf",
  "common.title": "Titel",
  "common.all": "Alle",
  "common.main": "Haupt",
  "common.pleaseSelect": "Bitte wählen",
  "common.activate": "Aktivieren",
  "common.deactivate": "Deaktivieren",
  "common.error": "Fehler",
  "common.date": "Datum",
  "common.selected": "ausgewählt",
  "common.selectAll": "Alle auswählen",
  "common.deselectAll": "Alle abwählen",
  "common.noResults": "Keine Ergebnisse",
  "common.copied": "Kopiert",
  "common.rename": "Umbenennen",
  "common.reset": "Zurücksetzen",

  // --- Auth / Login ---
  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.emailPlaceholder": "name@beispiel.com",
  "auth.passwordPlaceholder": "Passwort eingeben",
  "auth.forgotPassword": "Passwort vergessen?",
  "auth.login": "Anmelden",
  "auth.loggingIn": "Anmeldung...",
  "auth.logout": "Abmelden",
  "auth.loginError": "E-Mail oder Passwort ist nicht korrekt",
  "auth.connectionError": "Verbindungsfehler. Server nicht erreichbar.",

  // --- Forgot Password ---
  "forgot.title": "Passwort vergessen",
  "forgot.description": "Gib deine E-Mail ein. Du erhältst einen Link zum Zurücksetzen.",
  "forgot.send": "Link senden",
  "forgot.sending": "Wird gesendet...",
  "forgot.success": "E-Mail gesendet",
  "forgot.successMsg": "Falls ein Account mit dieser E-Mail existiert, wurde ein Link zum Zurücksetzen gesendet.",
  "forgot.backToLogin": "Zurück zum Login",
  "forgot.error": "Ein Fehler ist aufgetreten.",

  // --- Reset Password ---
  "reset.checking": "Link wird überprüft...",
  "reset.newPassword": "Neues Passwort",
  "reset.confirmPassword": "Passwort bestätigen",
  "reset.minChars": "Mindestens 12 Zeichen",
  "reset.repeatPassword": "Passwort wiederholen",
  "reset.tooShort": "Passwort muss mindestens 12 Zeichen lang sein.",
  "reset.mismatch": "Passwörter stimmen nicht überein.",
  "reset.charsNeeded": "Noch {n} Zeichen nötig",
  "reset.longEnough": "Passwort ist lang genug",
  "reset.passwordsMismatch": "Passwörter stimmen nicht überein",
  "reset.submit": "Passwort ändern",
  "reset.submitting": "Wird geändert...",
  "reset.masterError": "Nicht möglich",
  "reset.invalidLink": "Link ungültig",
  "reset.masterMsg": "Das Master-Passwort kann nur in den Server-Einstellungen geändert werden.",
  "reset.expiredMsg": "Dieser Link ist ungültig oder abgelaufen.",
  "reset.requestNew": "Neuen Link anfordern",
  "reset.success": "Passwort wurde geändert. Du kannst dich jetzt einloggen.",
  "reset.backToLogin": "Zurück zum Login",

  // --- Admin Sidebar ---
  "adminSidebar.dashboard": "Dashboard",
  "adminSidebar.kunden": "Kunden",
  "adminSidebar.newKunde": "Neuer Kunde",
  "adminSidebar.settings": "Einstellungen",
  "adminSidebar.collapse": "Einklappen",

  // --- Admin Dashboard ---
  "dashboard.title": "Dashboard",
  "dashboard.subtitle": "Übersicht aller Kunden",
  "dashboard.totalKunden": "Kunden gesamt",
  "dashboard.activeKunden": "Aktive Kunden",
  "dashboard.cmsEnabled": "CMS aktiviert",
  "dashboard.newKunde": "+ Neuer Kunde",
  "dashboard.recentChanges": "Letzte Änderungen",
  "dashboard.noChanges": "Keine Änderungen vorhanden.",

  // --- Kunden List ---
  "kunden.title": "Kunden",
  "kunden.newKunde": "Neuer Kunde",
  "kunden.newPassword": "Neues Passwort:",
  "kunden.noResults": "Keine Treffer.",
  "kunden.empty": "Noch keine Kunden vorhanden.",
  "kunden.modules": "Module",
  "kunden.cms": "CMS",
  "kunden.statusUpdated": "Status aktualisiert",
  "kunden.resetPassword": "Passwort zurücksetzen",
  "kunden.openCms": "CMS öffnen",
  "kunden.confirmDelete": "\"{name}\" wirklich löschen?\nAlle Daten ({pages} Seiten, {posts} Posts, {media} Medien) werden unwiderruflich gelöscht.",
  "kunden.deleted": "Kunde wurde gelöscht",

  // --- New Kunde ---
  "newKunde.title": "Neuer Kunde",
  "newKunde.sectionKunde": "Kunde",
  "newKunde.sectionUser": "Erster Benutzer",
  "newKunde.sectionOptional": "Optionale Einstellungen",
  "newKunde.sectionModules": "Module",
  "newKunde.namePlaceholder": "Hotel Beispiel",
  "newKunde.slugPlaceholder": "hotel-beispiel",
  "newKunde.domainPlaceholder": "www.hotel-beispiel.com",
  "newKunde.contactEmail": "Kontakt E-Mail (optional)",
  "newKunde.contactPlaceholder": "info@hotel-beispiel.com",
  "newKunde.loginEmail": "Login E-Mail *",
  "newKunde.loginEmailPlaceholder": "max@hotel-beispiel.com",
  "newKunde.generate": "Generieren",
  "newKunde.orKey": "OpenRouter Key (optional)",
  "newKunde.orModel": "OpenRouter Model (optional)",
  "newKunde.orModelPlaceholder": "z.B. anthropic/claude-sonnet-4",
  "newKunde.cmsActive": "CMS sofort aktivieren",
  "newKunde.sendEmail": "Zugangsdaten per E-Mail senden",
  "newKunde.submit": "Kunde erstellen",
  "newKunde.submitting": "Erstellen...",
  "newKunde.fillRequired": "Bitte alle Pflichtfelder (Name, Slug, Domain) ausfüllen.",
  "newKunde.fillUserRequired": "Bitte alle Benutzer-Pflichtfelder (Name, E-Mail, Passwort) ausfüllen.",
  "newKunde.created": "Kunde {name} wurde angelegt",
  "newKunde.emailSent": "Zugangsdaten per E-Mail gesendet",
  "newKunde.emailFailed": "E-Mail konnte nicht gesendet werden",

  // --- Kunde Detail (Tabs) ---
  "kundeDetail.pages": "Seiten",
  "kundeDetail.posts": "Posts",
  "kundeDetail.media": "Medien",
  "kundeDetail.aiGenerate": "AI Generieren",
  "kundeDetail.tabGeneral": "Allgemein",
  "kundeDetail.tabDesign": "Design",
  "kundeDetail.tabSeo": "SEO & Marketing",
  "kundeDetail.tabLegal": "Recht & Cookie",
  "kundeDetail.tabContent": "Inhalte",
  "kundeDetail.tabAccess": "Zugang",
  "kundeDetail.tabHistory": "Verlauf",
  "kundeDetail.changesSaved": "Änderungen gespeichert",
  "kundeDetail.notFound": "Kunde nicht gefunden",
  "kundeDetail.confirmDelete": "\"{name}\" wirklich löschen?\nAlle Daten ({pages} Seiten, {posts} Posts, {media} Medien) werden unwiderruflich gelöscht.",
  "kundeDetail.deleted": "Kunde wurde gelöscht",
  "kundeDetail.aiModalTitle": "Seite mit AI generieren",
  "kundeDetail.aiPageName": "Seitenname",
  "kundeDetail.aiPageNamePlaceholder": "z.B. Startseite, Über uns, Kontakt",
  "kundeDetail.aiDescription": "Beschreibung *",
  "kundeDetail.aiDescPlaceholder": "Beschreibe den Inhalt der Seite. Z.B.: Eine Startseite für ein Hotel in Südtirol mit Hero-Bereich, Zimmerübersicht als Karten, und Kontaktinfos.",
  "kundeDetail.aiStyle": "Stil / Ton (optional)",
  "kundeDetail.aiStylePlaceholder": "z.B. professionell, freundlich, modern",
  "kundeDetail.aiGenerating": "Generiert...",
  "kundeDetail.aiGenerateButton": "Generieren",
  "kundeDetail.aiPageCreated": "Seite \"{name}\" mit {count} Sektionen erstellt",
  "kundeDetail.previewTitle": "Vorschau generierter Text",
  "kundeDetail.textCopied": "Text kopiert",
  "kundeDetail.pagesCreated": "{count} Seite(n) erstellt ({names})",
  "kundeDetail.alreadyExists": "{count} bereits vorhanden",
  "kundeDetail.done": "Fertig",
  "kundeDetail.confirmDeleteOrKey": "OpenRouter Key wirklich löschen?",
  "kundeDetail.confirmDeleteRedirect": "Weiterleitung wirklich löschen?",
  "kundeDetail.legalGenerateError": "Fehler beim Generieren",

  // --- Kunde Detail: General Tab ---
  "general.contactEmail": "Kontakt E-Mail",
  "general.contactPlaceholder": "info@kunde.com",
  "general.orKey": "OpenRouter Key (optional)",
  "general.keyDeleted": "Key gelöscht",
  "general.keySaved": "Key gespeichert",
  "general.newKeyOnSave": "Neuer Key wird beim Speichern gesetzt",
  "general.noKey": "Kein Key",
  "general.orModel": "OpenRouter Model (optional)",
  "general.orModelPlaceholder": "z.B. anthropic/claude-sonnet-4",
  "general.cmsActive": "CMS aktiv",
  "general.kundeActive": "Kunde aktiv",
  "general.systemPrompt": "System Prompt",
  "general.systemPromptPlaceholder": "Individueller System Prompt für den Kunden...",
  "general.languages": "Sprachen",
  "general.mainLanguage": "Hauptsprache",
  "general.mainBadge": "(Haupt)",
  "general.availableLanguages": "Verfügbare Sprachen",

  // --- Kunde Detail: Design Tab ---
  "design.branding": "Branding",
  "design.logo": "Logo",
  "design.uploadLogo": "Logo hochladen",
  "design.svgRecommended": "SVG empfohlen für beste Qualität",
  "design.orEnterUrl": "oder URL eingeben",
  "design.favicon": "Favicon",
  "design.uploadFavicon": "Favicon hochladen",
  "design.faviconFormats": "SVG, PNG oder ICO",
  "design.colors": "Farben",
  "design.primaryColor": "Primärfarbe",
  "design.secondaryColor": "Sekundärfarbe",
  "design.backgroundColor": "Hintergrund",
  "design.textColor": "Textfarbe",
  "design.headingColor": "Überschriften",
  "design.footerBg": "Footer Hintergrund",
  "design.typography": "Typografie",
  "design.headings": "Überschriften",
  "design.textElements": "Text & Elemente",
  "design.preview": "Vorschau",
  "design.fontFamily": "Schriftart",
  "design.systemFont": "— System Font —",
  "design.customFont": "Eigene Schrift (WOFF2/TTF/OTF)",
  "design.removeFont": "Schrift entfernen",
  "design.fontWeight": "Gewicht",
  "design.fontSize": "Größe (rem)",
  "design.lineHeight": "Zeilenhöhe",
  "design.fontColor": "Farbe",
  "design.textStyle": "Textstil",
  "design.letterSpacing": "Zeichenabstand (em)",
  "design.normal": "Normal",
  "design.uppercase": "GROSSBUCHSTABEN",
  "design.lowercase": "kleinbuchstaben",
  "design.capitalize": "Erster Buchstabe Groß",
  "design.or": "oder",
  "design.pasteUrl": "URL einfügen",
  "design.removeLogo": "Logo entfernen",
  "design.removeFavicon": "Favicon entfernen",
  "design.uploaded": "Hochgeladen",
  "design.uploadFailed": "Upload fehlgeschlagen",
  "design.fontUploaded": "Schrift \"{name}\" hochgeladen",
  "design.bodyLabel": "Inhalt",
  "design.previewH1": "Hauptüberschrift",
  "design.previewH2": "Zwischenüberschrift",
  "design.previewH3": "Unterüberschrift",
  "design.previewH4": "Kleine Überschrift",
  "design.previewBody": "Dies ist ein Beispieltext für den Fließtext der Website.",
  "design.previewNav": "Startseite  Über uns  Kontakt",
  "design.previewFooter": "© 2026 Firmenname. Alle Rechte vorbehalten.",
  "design.previewButton": "Jetzt anfragen",

  // --- Kunde Detail: SEO Tab ---
  "seo.seoAnalytics": "SEO & Analytics",
  "seo.metaTitle": "Meta Title (Standard)",
  "seo.metaTitlePlaceholder": "z.B. Bergblick Apartments",
  "seo.titleSuffix": "Title Suffix",
  "seo.titleSuffixPlaceholder": "z.B. | Bergblick Apartments",
  "seo.previewLabel": "Vorschau:",
  "seo.pageName": "Seitenname",
  "seo.metaDescription": "Meta Description",
  "seo.metaDescPlaceholder": "Standard-Beschreibung für Suchmaschinen (150-160 Zeichen optimal)",
  "seo.chars": "Zeichen",
  "seo.metaKeywords": "Meta Keywords",
  "seo.metaKeywordsPlaceholder": "z.B. hotel, südtirol, urlaub",
  "seo.analyticsId": "Google Analytics ID",
  "seo.analyticsPlaceholder": "z.B. G-XXXXXXXXXX",
  "seo.tagManagerId": "Tag Manager ID",
  "seo.tagManagerPlaceholder": "z.B. GTM-XXXXXXX",
  "seo.tagManagerHint": "Google Tag Manager Container ID",
  "seo.noIndex": "Website für Suchmaschinen sperren",
  "seo.noIndexHint": "Aktiviert noindex/nofollow auf allen Seiten. Für Development/Beta empfohlen.",
  "seo.ogImage": "Standard OG Bild",
  "seo.ogImagePlaceholder": "https://... (1200×630px empfohlen)",
  "seo.ogImageHint": "Wird verwendet wenn eine Seite kein eigenes OG Bild hat. Empfohlen: 1200×630px",
  "seo.branding": "Logo & Favicon für Suchmaschinen",
  "seo.brandingHint": "Eigene Dateien für Google & Co.: Schema.org-Logo (Knowledge Panel) und das Icon neben dem Suchergebnis. Leer = Logo/Favicon aus dem Tab „Design“. Sinnvoll, wenn das Website-Logo weiß ist und auf hellem Grund verschwindet.",
  "seo.logo": "SEO-Logo",
  "seo.logoHint": "Dunkles Motiv auf hellem oder deckendem Grund, mind. 112×112px, PNG oder SVG.",
  "seo.favicon": "SEO-Favicon",
  "seo.faviconHint": "Quadratisch, mind. 48×48px (Google), PNG, SVG oder ICO.",
  "seo.brandingFallbackActive": "Derzeit wird die Datei aus dem Tab „Design“ verwendet.",
  "seo.verification": "Suchmaschinen Verifikation",
  "seo.googleVerification": "Google Verification Code",
  "seo.googleVerificationHint": "Aus Google Search Console → Einstellungen → Eigentumsnachweis",
  "seo.bingVerification": "Bing Verification Code",
  "seo.bingVerificationHint": "Aus Bing Webmaster Tools",
  "seo.businessInfo": "Business Informationen (Schema.org)",
  "seo.businessType": "Business Typ",
  "seo.openingHours": "Öffnungszeiten (strukturiert für Schema.org)",
  "seo.openingHoursFormat": "Format: HH:MM-HH:MM (z.B. 08:00-18:00). Leer = geschlossen an diesem Tag.",
  "seo.timeExample": "z.B. 08:00-18:00",
  "seo.closedHint": "leer = geschlossen",
  "seo.socialMedia": "Soziale Medien",
  "seo.socialHint": "Werden auch für Schema.org sameAs und Footer-Links verwendet.",
  "seo.days.mo": "Mo",
  "seo.days.di": "Di",
  "seo.days.mi": "Mi",
  "seo.days.do": "Do",
  "seo.days.fr": "Fr",
  "seo.days.sa": "Sa",
  "seo.days.so": "So",

  // --- Kunde Detail: Legal Tab ---
  "legal.title": "Impressum / Rechtliches",
  "legal.company": "Unternehmen",
  "legal.companyName": "Firmenname",
  "legal.companyNamePlaceholder": "z.B. Mustermann GmbH",
  "legal.legalForm": "Rechtsform",
  "legal.noSelection": "— Keine Auswahl —",
  "legal.vatId": "Partita IVA (USt-IdNr)",
  "legal.vatIdPlaceholder": "z.B. IT01234567890",
  "legal.taxCode": "Codice Fiscale (Steuernr)",
  "legal.taxCodePlaceholder": "z.B. 01234567890",
  "legal.tradeRegister": "Registro Imprese (Handelsregister)",
  "legal.tradeRegisterPlaceholder": "z.B. BZ-123456",
  "legal.reaNumber": "REA Nummer",
  "legal.address": "Adresse",
  "legal.street": "Straße + Nr.",
  "legal.streetPlaceholder": "z.B. Musterstraße 1",
  "legal.zip": "PLZ",
  "legal.zipPlaceholder": "z.B. 39100",
  "legal.city": "Ort",
  "legal.cityPlaceholder": "z.B. Bozen",
  "legal.province": "Provinz",
  "legal.provincePlaceholder": "z.B. BZ",
  "legal.country": "Land",
  "legal.countryPlaceholder": "z.B. IT",
  "legal.contact": "Kontakt",
  "legal.phone": "Telefon",
  "legal.phonePlaceholder": "z.B. +39 0471 123456",
  "legal.emailImprint": "E-Mail (Impressum)",
  "legal.emailPlaceholder": "z.B. info@firma.it",
  "legal.pec": "PEC",
  "legal.pecPlaceholder": "z.B. firma@pec.it",
  "legal.websiteUrl": "Website URL",
  "legal.websitePlaceholder": "z.B. https://www.firma.it",
  "legal.responsible": "Verantwortlicher / Kapital",
  "legal.owner": "Inhaber / Gesetzl. Vertreter",
  "legal.ownerPlaceholder": "z.B. Max Mustermann",
  "legal.capital": "Stammkapital",
  "legal.capitalPlaceholder": "z.B. 10.000,00 EUR",
  "legal.mediaSources": "Quellenangaben Medieninhalte",
  "legal.mediaSourcesPlaceholder": "Fotos: © Max Mustermann / Shutterstock\nIcons: Lucide Icons (MIT License)\nVideos: © Firma XY",
  "legal.mediaSourcesHint": "Quellen für Bilder, Videos und andere Medieninhalte (eine Quelle pro Zeile)",
  "legal.imprintTexts": "Impressum-Texte (optional)",
  "legal.imprintTextsHint": "Leer lassen für automatische Generierung aus den obigen Daten.",
  "legal.privacyTexts": "Datenschutz-Texte (optional)",
  "legal.privacyTextsHint": "Leer lassen für automatische Generierung aus den Kundendaten.",
  "legal.cookieBanner": "Cookie Banner",
  "legal.cookieActive": "Cookie Banner aktiv",
  "legal.privacyUrl": "Datenschutz URL",
  "legal.privacyUrlPlaceholder": "z.B. /datenschutz oder https://...",
  "legal.allDefaults": "Alle Standard-Texte einfügen",
  "legal.generatePages": "Seiten automatisch generieren",
  "legal.generatePagesDesc": "Erstellt Impressum und Datenschutz Seiten automatisch aus den eingetragenen Daten. Bereits vorhandene Seiten werden **nicht** überschrieben.",
  "legal.generatePagesHint": "Bitte zuerst Firmenname, Ort und E-Mail eintragen.",
  "legal.generating": "Generiert...",
  "legal.generateButton": "Impressum + Datenschutz Seiten erstellen",

  // --- Kunde Detail: Content Tab ---
  "content.openingHours": "Öffnungszeiten",
  "content.openingHoursLabel": "Öffnungszeiten (Freitext)",
  "content.openingHoursPlaceholder": "Mo-Fr: 08:00-18:00\nSa: 09:00-13:00\nSo: geschlossen",
  "content.contactForm": "Kontaktformular",
  "content.recipientEmail": "Empfänger E-Mail",
  "content.recipientPlaceholder": "z.B. info@firma.it",
  "content.defaultSubject": "Standard Betreff",
  "content.subjectPlaceholder": "z.B. Kontaktanfrage Website",
  "content.sendTestAnfrage": "Testanfrage senden",
  "content.testAnfrageSent": "2 Test-E-Mails an {email} gesendet ({sent})",
  "content.testAnfrageError": "Test-E-Mails konnten nicht gesendet werden",
  "content.testAnfrageHint": "Sendet 2 E-Mails an die Super Admin Adresse: Benachrichtigung (an Betreiber) + Bestätigung (an Absender). Verwendet das Kunden-Logo und die Primärfarbe.",
  "content.booking": "Buchung / Reservierung",
  "content.bookingUrl": "Externe Buchungs-URL",
  "content.bookingPlaceholder": "z.B. https://booking.com/hotel/...",
  "content.bookingHint": "z.B. Booking.com oder eigenes System",
  "content.footerText": "Footer Text",
  "content.footerTextPlaceholder": "z.B. © 2026 Firma GmbH. Alle Rechte vorbehalten.",
  "content.footerTextHint": "Kurzer Text der im Footer der Website angezeigt wird",
  "content.specialPages": "Spezielle Seiten",
  "content.thankYouImage": "Dankeseite Bild URL",
  "content.thankYouPlaceholder": "URL aus Medienbibliothek",
  "content.thankYouHint": "Wird nach Formular-Absendung gezeigt",
  "content.errorPageImage": "404 Fehlerseite Bild URL",
  "content.errorPageHint": "Wird bei nicht gefundenen Seiten gezeigt",
  "content.modules": "Module",
  "content.modulesManaged": "Module werden über die eigene Konfigurationsseite verwaltet.",
  "content.configureModules": "Module konfigurieren",

  // --- Kunde Detail: Access Tab ---
  "access.permissions": "Berechtigungen für Benutzer",
  "access.masterHint": "Master hat immer vollen Zugriff. Admin darf nie weniger als Editor.",
  "access.permission": "Berechtigung",
  "access.savePermissions": "Berechtigungen speichern",
  "access.editPages": "Seiten bearbeiten",
  "access.createPages": "Seiten erstellen",
  "access.deletePages": "Seiten löschen",
  "access.editMeta": "SEO/Meta bearbeiten",
  "access.uploadMedia": "Medien hochladen",
  "access.deleteMedia": "Medien löschen",
  "access.editModules": "Module bearbeiten",
  "access.createModules": "Module erstellen",
  "access.deleteModules": "Module löschen",
  "access.useChat": "Chat nutzen",
  "access.manageUsers": "Benutzer verwalten",
  "access.users": "Benutzer",
  "access.newUser": "Neuer Benutzer",
  "access.noUsers": "Noch keine Benutzer angelegt.",
  "access.noUsersHint": "Erstellen Sie einen Benutzer, damit sich der Kunde einloggen kann.",
  "access.lastLogin": "Letzter Login",
  "access.editUser": "Benutzer bearbeiten",
  "access.generatedPassword": "Generiertes Passwort:",
  "access.sendCredentials": "Zugangsdaten per E-Mail senden",
  "access.namePlaceholder": "Max Mustermann",
  "access.emailPlaceholder": "max@beispiel.de",
  "access.userCreated": "Benutzer erstellt",
  "access.userUpdated": "Benutzer aktualisiert",
  "access.userDeleted": "Benutzer gelöscht",
  "access.newPasswordToast": "Neues Passwort: {password}",
  "access.confirmDeleteUser": "\"{name}\" wirklich löschen?",
  "access.deactivate": "Deaktivieren",
  "access.activate": "Aktivieren",

  // --- Kunde Detail: History Tab ---
  "history.noChanges": "Keine Änderungen vorhanden.",

  // --- Redirects ---
  "redirects.title": "Weiterleitungen",
  "redirects.new": "Neue Weiterleitung",
  "redirects.from": "Von",
  "redirects.fromPlaceholder": "/alter-pfad",
  "redirects.to": "Zu",
  "redirects.toPlaceholder": "/neuer-pfad oder https://...",
  "redirects.type": "Typ",
  "redirects.permanent": "301 (Permanent)",
  "redirects.temporary": "302 (Temporär)",
  "redirects.created": "Weiterleitung erstellt",
  "redirects.deleted": "Weiterleitung gelöscht",
  "redirects.empty": "Noch keine Weiterleitungen angelegt.",
  "redirects.fromRequired": "Von und Zu sind Pflichtfelder",
  "redirects.fromSlash": "Von-Pfad muss mit / beginnen",
  "redirects.toSlash": "Zu-Pfad muss mit / oder https:// beginnen",
  "redirects.sameError": "Von und Zu dürfen nicht identisch sein",
  "redirects.export": "Links exportieren",
  "redirects.exportTitle": "Verfügbare Links",
  "redirects.exportEmpty": "Keine Links gefunden.",
  "redirects.exportError": "Fehler beim Laden der Links",
  "redirects.exportFilter": "Filtern nach URL oder Titel...",
  "redirects.exportHint": "Alle aktuellen Seiten-URLs des Kunden (inkl. mehrsprachiger Slugs).",
  "redirects.copyAll": "Alle kopieren",
  "redirects.useAsTarget": "Als Ziel",
  "redirects.exportCsv": "Als CSV (Excel)",

  // --- Admin Settings ---
  "adminSettings.title": "Einstellungen",
  "adminSettings.appearance": "Erscheinungsbild",
  "adminSettings.logoHint": "Logo wird in Sidebar, Login und E-Mails angezeigt. Empfohlen: PNG oder SVG, transparent, max 400x120px.",
  "adminSettings.uploadLogo": "Logo hochladen",
  "adminSettings.svgBest": "SVG empfohlen für beste Qualität",
  "adminSettings.loginBg": "Login Hintergrundbild",
  "adminSettings.loginBgHint": "Wird auf der Login-, Passwort-vergessen- und Reset-Seite angezeigt. Empfohlen: min 1920x1080px, JPG oder WebP.",
  "adminSettings.uploadImage": "Bild hochladen",
  "adminSettings.confirmRemoveLogo": "Logo wirklich entfernen?",
  "adminSettings.logoUploaded": "Logo hochgeladen",
  "adminSettings.logoRemoved": "Logo entfernt",
  "adminSettings.confirmRemoveBg": "Hintergrundbild wirklich entfernen?",
  "adminSettings.bgUploaded": "Hintergrundbild hochgeladen",
  "adminSettings.bgRemoved": "Hintergrundbild entfernt",
  "adminSettings.onlyImageFormats": "Nur PNG, JPG, SVG oder WebP erlaubt",
  "adminSettings.fileTooLarge5": "Datei zu groß (max 5MB)",
  "adminSettings.onlyImageFormatsNoBg": "Nur PNG, JPG oder WebP erlaubt",
  "adminSettings.fileTooLarge10": "Datei zu groß (max 10MB)",
  "adminSettings.uploadFailed": "Upload fehlgeschlagen",
  "adminSettings.removeFailed": "Fehler beim Entfernen",
  "adminSettings.emailSystem": "E-Mail System",
  "adminSettings.statusLabel": "Status:",
  "adminSettings.emailConnected": "Resend verbunden",
  "adminSettings.emailNotConfigured": "Nicht konfiguriert",
  "adminSettings.sender": "Absender",
  "adminSettings.alertEmail": "Alert E-Mail",
  "adminSettings.sendTest": "Test E-Mail senden",
  "adminSettings.sendingTest": "Sende...",
  "adminSettings.testSent": "Test E-Mail gesendet an {email}",
  "adminSettings.testFailed": "E-Mail konnte nicht gesendet werden",
  "adminSettings.masterPassword": "Master Passwort ändern",
  "adminSettings.currentPassword": "Aktuelles Passwort",
  "adminSettings.newPassword": "Neues Passwort",
  "adminSettings.minChars": "Mindestens 8 Zeichen",
  "adminSettings.fillBoth": "Bitte beide Felder ausfüllen.",
  "adminSettings.passwordChanged": "Passwort erfolgreich geändert",
  "adminSettings.changePassword": "Passwort ändern",
  "adminSettings.serverInfo": "Server Informationen",
  "adminSettings.nodeJs": "Node.js",
  "adminSettings.platform": "Plattform",
  "adminSettings.uptime": "Uptime",
  "adminSettings.environment": "Environment",
  "adminSettings.database": "Datenbank",

  // --- Kunde Sidebar ---
  "kundeSidebar.overview": "Übersicht",
  "kundeSidebar.pages": "Seiten",
  "kundeSidebar.blog": "Blog",
  "kundeSidebar.chat": "Chat",
  "kundeSidebar.users": "Benutzer",
  "kundeSidebar.media": "Medien",
  "kundeSidebar.settings": "Einstellungen",
  "kundeSidebar.collapse": "Einklappen",
  "kundeSidebar.openWebsite": "Website öffnen",

  // --- Kunde Overview ---
  "overview.title": "Übersicht",
  "overview.welcome": "Willkommen im CMS",
  "overview.pages": "Seiten",
  "overview.blogPosts": "Blog Posts",
  "overview.media": "Medien",
  "overview.quickAccess": "Schnellzugriff",
  "overview.editPages": "Seiten bearbeiten",
  "overview.manageBlog": "Blog verwalten",
  "overview.uploadMedia": "Medien hochladen",
  "overview.settings": "Einstellungen",
  "overview.recentChanges": "Letzte Änderungen",
  "overview.settingsDesc": "Kontakt, Passwort, SEO",
  "overview.modules": "Module",
  "overview.chatDesc": "Inhalte per KI ändern",
  "overview.users": "Benutzer",
  "overview.usersDesc": "Benutzer verwalten",

  // --- Super Admin Banner ---
  "superAdmin.banner": "Super Admin Ansicht:",
  "superAdmin.backToAdmin": "Zurück zum Admin",
  "superAdmin.badge": "Super Admin",
  "superAdmin.switchKunde": "Kunde wechseln",
  "superAdmin.searchKunde": "Kunde suchen…",
  "superAdmin.noKunden": "Keine Kunden gefunden",
  "superAdmin.loadError": "Kunden konnten nicht geladen werden",

  // --- Sidebar (gemeinsam) ---
  "sidebar.language": "Sprache",
  "sidebar.expand": "Ausklappen",
  "sidebar.groupContent": "Inhalte",
  "sidebar.groupAi": "KI",
  "sidebar.groupAdmin": "Verwaltung",
  "sidebar.roleMaster": "Master",
  "sidebar.roleAdmin": "Admin",
  "sidebar.roleEditor": "Editor",

  // --- Kunde Layout Errors ---
  "kundeLayout.notAuthorized": "Nicht autorisiert. Bitte erneut einloggen.",
  "kundeLayout.loadError": "Fehler beim Laden der Kundendaten.",
  "kundeLayout.networkError": "Netzwerkfehler. Server nicht erreichbar.",
  "kundeLayout.genericError": "Kundendaten konnten nicht geladen werden.",
  "kundeLayout.retry": "Erneut versuchen",

  // --- Pages Editor ---
  "pages.title": "Seiten",
  "pages.newPage": "Neue Seite",
  "pages.normal": "Inhaltsseiten",
  "pages.landing": "Landingpages",
  "pages.all": "Alle Seiten",
  "pages.isLanding": "Landingpage",
  "pages.isLandingDesc": "Wird nicht im Menü angezeigt",
  "pages.normalPage": "Normale Seite",
  "pages.landingShort": "Landing",
  "pages.pageShort": "Seite",
  "pages.filterLabel": "Anzeigen",
  "pages.import": "Importieren",
  "pages.export": "Exportieren",
  "pages.searchPlaceholder": "Seiten suchen…",
  "pages.clearSearch": "Suche löschen",
  "pages.noSearchResults": "Keine passenden Seiten",
  "pages.collapse": "Unterseiten einklappen",
  "pages.expand": "Unterseiten aufklappen",
  "pages.viewLive": "Live ansehen",
  "pages.translationMissing": "{fehlend} von {gesamt} Texten fehlen auf {sprache}",
  "pages.translationMissingChildren": "inkl. Unterseiten",
  "pages.translationIncomplete": "unvollständig",
  "pages.notInMenu": "Nicht im Menü",
  "pages.saved": "Seite gespeichert",
  "pages.deleted": "Seite gelöscht",
  "pages.created": "Seite angelegt",
  "pages.sectionCopied": "Sektion kopiert",
  "pages.sectionCopiedTo": "Sektion auf \u201E{page}\u201C kopiert",
  "pages.duplicate": "Duplizieren",
  "pages.duplicatePage": "Seite duplizieren",
  "pages.duplicated": "Seite dupliziert",
  "pages.copySuffix": "Kopie",
  "pages.duplicateSource": "Kopie von „{page}“ mit allen Sektionen, SEO-Daten und Übersetzungen.",
  "pages.duplicateShowInMenu": "Kopie im Menü anzeigen",
  "pages.duplicateShowInMenuDesc": "Standardmäßig bleibt die Kopie ausgeblendet, bis sie bearbeitet wurde.",
  "pages.copySection": "Sektion kopieren",
  "pages.copyToOtherPage": "Auf andere Seite kopieren",
  "pages.copyError": "Fehler beim Kopieren",
  "pages.uniqueIds": "Sektions-IDs müssen eindeutig sein",
  "pages.invalidId": "Ungültige Sektions-ID: \"{id}\"",
  "pages.invalidClass": "Ungültige CSS Klasse: \"{class}\"",
  "pages.parentPage": "Übergeordnete Seite",
  "pages.template": "Vorlage",
  "pages.homepage": "Startseite",
  "pages.hidden": "versteckt",
  "pages.sectionId": "ID / Anker",
  "pages.cssClass": "CSS Klasse",
  "pages.seo": "SEO",
  "pages.metaTitle": "Meta Title",
  "pages.metaDescription": "Meta Description",
  "pages.ogImage": "OG Bild",
  "pages.socialMedia": "Social Media (Open Graph)",
  "pages.socialMediaDesc": "Titel, Beschreibung und Bild für geteilte Links (WhatsApp, Facebook, LinkedIn). Leer = Meta Title / Meta Description werden verwendet.",
  "pages.ogTitle": "OG Titel",
  "pages.ogTitlePlaceholder": "Titel beim Teilen (leer = Meta Title)",
  "pages.ogDescription": "OG Beschreibung",
  "pages.ogDescPlaceholder": "Beschreibung beim Teilen (leer = Meta Description)",
  "pages.canonical": "Kanonisch",
  "pages.schema": "Schema",
  "pages.modulAsSubmenu": "Modul als Untermenü",
  "pages.selectModule": "Modul wählen",
  "pages.onThisPage": "Auf dieser Seite",
  "pages.addSection": "Sektion hinzufügen",
  "pages.unnamedSection": "Neue Sektion",
  "pages.addField": "Feld hinzufügen",
  "pages.advancedIdClass": "Erweitert · ID & CSS-Klasse",
  "pages.addElement": "Element hinzufügen",
  "pages.noElements": "Noch keine Elemente. Füge unten das erste hinzu.",
  "pages.elementPalette": "Element auswählen",
  "pages.noPageSelected": "Wähle eine Seite aus der Liste oder erstelle eine neue.",
  "pages.fieldExists": "Feld existiert bereits",
  "pages.noTranslatableTexts": "Keine übersetzbaren Texte gefunden",
  "pages.chooseOtherLanguage": "Bitte eine andere Zielsprache wählen",
  "pages.textsTranslated": "{count} Texte übersetzt",
  "pages.textsTranslatedPartial": "{count} Texte übersetzt, {missing} fehlgeschlagen – bitte erneut übersetzen",
  "pages.translationFailed": "Übersetzung fehlgeschlagen",
  "pages.confirmDeleteEntry": "Eintrag wirklich löschen?",
  "pages.hide": "Ausblenden",
  "pages.show": "Einblenden",
  "pages.idAndClass": "ID & Klasse",
  "pages.duplicateLabel": "{label} duplizieren",
  "pages.removeLabel": "{label} entfernen",
  "pages.autoTranslate": "Automatisch übersetzen",
  "pages.sourceLanguage": "Quellsprache",
  "pages.targetLanguage": "Zielsprache",
  "pages.translate": "Übersetzen",
  "pages.translating": "Übersetze...",
  "pages.deleteTranslation": "Übersetzung löschen",
  "pages.translationDeleted": "Übersetzung gelöscht – Seite speichern um Änderungen zu übernehmen",
  "pages.deleteTranslationWarning": "Diese Aktion entfernt alle übersetzten Inhalte für die gewählte Sprache auf dieser Seite.",
  "pages.deleteTranslationConfirm": "Ich möchte die Übersetzung unwiderruflich löschen",
  "pages.fallbackHint": "Hauptsprache",
  "pages.clearFieldTranslation": "Übersetzung für dieses Feld löschen",
  "pages.fieldTranslationCleared": "Feld-Übersetzung gelöscht",
  "pages.removeFromMenu": "Aus Menü entfernen",
  "pages.showInMenu": "Im Menü anzeigen",
  "pages.confirmDelete": "Seite wirklich löschen?",
  "pages.selectMultiple": "Mehrere Seiten auswählen",

  // --- Seiten: Versionsverlauf ---
  "versions.title": "Versionen",
  "versions.open": "Versionen anzeigen",
  "versions.empty": "Noch keine Versionen. Sie entstehen beim Speichern.",
  "versions.current": "Aktueller Stand",
  "versions.loadedBadge": "Geladen",
  "versions.view": "Ansehen",
  "versions.loadError": "Versionen konnten nicht geladen werden",
  "versions.loaded": "Version vom {datum} geladen – noch nicht gespeichert.",
  "versions.restore": "Wiederherstellen",
  "versions.discard": "Verwerfen",
  "versions.hint": "Die letzten {n} Versionen jeder Seite werden aufbewahrt.",
  "versions.source.ausgangsstand": "Ausgangsstand",
  "versions.source.speichern": "Gespeichert",
  "versions.source.wiederherstellung": "Wiederhergestellt",
  "versions.source.ki": "KI",
  "versions.source.chat": "Chat",
  "versions.source.import": "Import",
  "versions.change.sectionChanged1": "1 Sektion geändert",
  "versions.change.sectionChangedN": "{n} Sektionen geändert",
  "versions.change.sectionAdded1": "1 Sektion hinzugefügt",
  "versions.change.sectionAddedN": "{n} Sektionen hinzugefügt",
  "versions.change.sectionRemoved1": "1 Sektion entfernt",
  "versions.change.sectionRemovedN": "{n} Sektionen entfernt",
  "versions.change.order": "Reihenfolge",
  "versions.change.title": "Titel",
  "versions.change.slug": "Slug",
  "versions.change.seo": "SEO",
  "versions.change.settings": "Einstellungen",
  "versions.change.none": "Keine inhaltliche Änderung",
  "versions.detail.show": "Details anzeigen",
  "versions.detail.hide": "Details ausblenden",
  "versions.detail.more": "+ {n} weitere Änderungen",
  "versions.detail.empty": "leer",
  "versions.detail.bereich.seite": "Seite",
  "versions.detail.bereich.seo": "SEO",
  "versions.detail.bereich.einstellungen": "Einstellungen",
  "versions.detail.sectionAdded": "Sektion hinzugefügt",
  "versions.detail.sectionRemoved": "Sektion entfernt",
  "versions.detail.fieldAdded": "hinzugefügt",
  "versions.detail.fieldRemoved": "entfernt",
  "versions.detail.titel": "Titel",
  "versions.detail.slug": "Slug",
  "versions.detail.name": "Name",
  "versions.detail.sichtbar": "Sichtbar",
  "versions.detail.anker": "ID / Anker",
  "versions.detail.klasse": "CSS-Klasse",
  "versions.detail.feldReihenfolge": "Reihenfolge der Felder",
  "versions.detail.sektionReihenfolge": "Reihenfolge der Sektionen",
  "versions.detail.elternseite": "Übergeordnete Seite",
  "versions.detail.modulUntermenue": "Modul als Untermenü",
  "versions.detail.menuVerhalten": "Menü-Verhalten",
  "versions.detail.menuNeuesTab": "In neuem Tab öffnen",
  "versions.detail.menuUrl": "Menü-URL",
  "versions.detail.landing": "Landingpage",
  "versions.detail.nurSprachen": "Veröffentlicht in",

  "pages.unsavedChanges": "Ungespeicherte Änderungen",
  "pages.savedAgo": "Gespeichert · {zeit}",
  "pages.translateShort": "Übersetzen",
  "pages.new": "Neu",
  "pages.emptyPage": "Leere Seite",
  "pages.collapseChildren": "Unterseiten einklappen",
  "pages.expandChildren": "Unterseiten ausklappen",
  "pages.pageActions": "Seitenaktionen",
  "pages.selectAll": "Alle auswählen ({count})",
  "pages.selectAllResults": "Alle Treffer auswählen ({count})",
  "pages.deleteSelected": "{count} löschen",
  "pages.confirmBulkDelete": "{count} Seiten wirklich löschen?\nDas kann nicht rückgängig gemacht werden.",
  "pages.bulkDeleted": "{count} Seiten gelöscht",
  "pages.homepageNotDeletable": "Die Startseite kann nicht gelöscht werden",
  "pages.confirmDeleteSection": "Sektion wirklich löschen?",
  "pages.noPages": "Keine Seiten vorhanden",
  "pages.selectPage": "Seite wählen...",
  "pages.pageTitle": "Seitentitel",
  "pages.sections": "Sektionen",
  "pages.noSections": "Keine Sektionen vorhanden",
  "pages.selectSection": "Sektion auswählen",
  "pages.content": "Inhalt",
  "pages.main": "Haupt",
  "pages.characters": "Zeichen",
  "pages.metaTitlePlaceholder": "Seitentitel für Suchmaschinen",
  "pages.metaTitlePlaceholderLong": "Seitentitel für Suchmaschinen (leer = Seitentitel)",
  "pages.metaDescPlaceholder": "Kurzbeschreibung für Suchergebnisse",
  "pages.schemaType": "Seiten Typ (Schema.org)",
  "pages.canonicalUrl": "Kanonische URL (optional)",
  "pages.canonicalPlaceholder": "https://... (nur setzen falls Seite Duplikat)",
  "pages.ogImagePlaceholder": "https://... (1200×630px, leer = Standard OG Bild)",
  "pages.previewImage": "Vorschaubild",
  "pages.modulAsSubmenuDesc": "Modul-Einträge als Unterpunkte in der Navigation anzeigen",
  "pages.noParent": "Keine (Hauptebene)",
  "pages.childrenWillBecomeTopLevel": "Unterseiten dieser Seite werden auf die Hauptebene verschoben.",
  "pages.menuTitle": "Menü-Verhalten",
  "pages.menuDesc": "Wie verhält sich dieser Eintrag im Hauptmenü?",
  "pages.menuVerhaltenSeite": "Link zu dieser Seite",
  "pages.menuVerhaltenSeiteDesc": "Standard – öffnet die Seite",
  "pages.menuVerhaltenLabel": "Nur Label (kein Link)",
  "pages.menuVerhaltenLabelDesc": "Wird im Menü angezeigt, ist aber nicht anklickbar",
  "pages.menuVerhaltenWeiterleitung": "Weiterleitung",
  "pages.menuVerhaltenWeiterleitungDesc": "Leitet auf eine andere URL (intern oder extern)",
  "pages.menuUrlLabel": "Ziel-URL",
  "pages.menuUrlPlaceholder": "https://… oder /pfad",
  "pages.menuUrlHelp": "Pro Sprache eintragen. Leer = greift Hauptsprache als Fallback.",
  "pages.menuNeuesTab": "In neuem Tab öffnen",
  "pages.nurSprachenTitle": "Veröffentlicht in",
  "pages.nurSprachenDesc": "In welchen Sprachen die Seite auf der Website erscheint. Standard: alle.",
  "pages.nurSprachenHinweis": "Nicht veröffentlicht in: {sprachen}. Aufrufe dieser Sprachversionen werden auf eine veröffentlichte Fassung umgeleitet; Menü, Sitemap und hreflang lassen sie weg.",
  "pages.nurSprachenMinEine": "Mindestens eine Sprache muss aktiv bleiben",
  "pages.homepageDesc": "Hauptseite ohne Slug",
  "pages.slug": "Slug",
  "pages.slugAutoGenerated": "Wird automatisch aus dem Namen generiert",
  "pages.fieldName": "Feldname",
  "pages.optionsComma": "Optionen (kommagetrennt)",
  "pages.customFields": "Eigene Felder",
  "pages.imagePosition": "Bild Position",
  "pages.spacing": "Abstand",
  "pages.entry": "Eintrag",
  "pages.module": "Modul",
  "pages.layout": "Layout",
  "pages.layoutCards": "Karten",
  "pages.layoutList": "Liste",
  "pages.layoutSlider": "Slider",
  "pages.count": "Anzahl",
  "pages.sorting": "Sortierung",
  "pages.sortNewest": "Neueste zuerst",
  "pages.sortOrder": "Reihenfolge",
  "pages.sortAlphabetical": "Alphabetisch",
  "pages.titlePlaceholder": "z.B. Unsere Referenzen",
  "pages.translatableFieldsFound": "{count} übersetzbare Textfelder gefunden",
  "pages.inclPageTitle": "inkl. Seitentitel",
  "pages.overwriteTranslations": "Bestehende Übersetzungen überschreiben",
  "pages.overwriteTranslationsHint": "Alle Felder neu übersetzen, auch bereits übersetzte.",
  "pages.idTaken": "ID bereits vergeben",
  "pages.fieldDuplicated": "{field} dupliziert",

  // --- Blog ---
  "blog.title": "Blog",
  "blog.newPost": "Neuer Post",
  "blog.empty": "Noch keine Posts vorhanden.",
  "blog.confirmDelete": "Post wirklich löschen?",
  "blog.deleted": "Post gelöscht",

  // --- Blog New ---
  "blogNew.title": "Neuer Post",
  "blogNew.titleLabel": "Titel *",
  "blogNew.titlePlaceholder": "Post Titel",
  "blogNew.slugLabel": "Slug *",
  "blogNew.slugPlaceholder": "post-slug",
  "blogNew.excerptLabel": "Excerpt",
  "blogNew.excerptPlaceholder": "Kurzbeschreibung...",
  "blogNew.contentLabel": "Inhalt",
  "blogNew.contentPlaceholder": "Inhalt des Posts...",
  "blogNew.imageLabel": "Bild URL",
  "blogNew.imagePlaceholder": "/uploads/...",
  "blogNew.published": "Veröffentlicht",
  "blogNew.draft": "Entwurf",
  "blogNew.required": "Titel und Slug erforderlich",
  "blogNew.created": "Post erstellt",
  "blogNew.submit": "Post erstellen",

  // --- Blog Edit ---
  "blogEdit.title": "Post bearbeiten",
  "blogEdit.notFound": "Post nicht gefunden.",
  "blogEdit.published": "Post veröffentlicht",
  "blogEdit.saved": "Post gespeichert",
  "blogEdit.deleted": "Post gelöscht",
  "blogEdit.confirmDelete": "Post wirklich löschen?",
  "blogEdit.titleLabel": "Titel",
  "blogEdit.slugLabel": "Slug",
  "blogEdit.excerptLabel": "Excerpt",
  "blogEdit.contentLabel": "Inhalt",
  "blogEdit.imageLabel": "Bild URL",

  // --- Module ---
  "module.title": "Module",
  "module.newModule": "Neues Modul",
  "module.empty": "Keine Module",
  "module.emptyHint": "Erstelle ein neues Modul für diesen Kunden.",
  "module.detailPage": "Detailseite",
  "module.categories": "Kategorien",
  "module.publication": "Veröffentlichung",
  "module.expiry": "Ablaufdatum",
  "module.configure": "Konfigurieren",
  "module.configureTitle": "Modul konfigurieren",
  "module.newTitle": "Neues Modul",
  "module.nameLabel": "Name",
  "module.namePlaceholder": "z.B. Zimmer",
  "module.keyLabel": "Key",
  "module.keyPlaceholder": "auto",
  "module.iconLabel": "Icon",
  "module.hasDetail": "Hat Detailseite",
  "module.hasCategories": "Hat Kategorien",
  "module.hasPublication": "Veröffentlichungsdatum",
  "module.hasExpiry": "Ablaufdatum",
  "module.unlimitedUpload": "Unbegrenzte Uploadgröße",
  "module.loadTemplate": "Vorlage laden",
  "module.fieldCount": "Felder ({count})",
  "module.addField": "Feld",
  "module.noFields": "Keine Felder. Wähle eine Vorlage oder füge Felder hinzu.",
  "module.nameKeyRequired": "Name und Key erforderlich",
  "module.updated": "Modul aktualisiert",
  "module.created": "Modul erstellt",
  "module.confirmDelete": "Modul \"{name}\" wirklich löschen?\n{count} Einträge werden ebenfalls gelöscht.",
  "module.deleted": "Modul gelöscht",
  "module.fieldLabel": "Label",
  "module.fieldKey": "key",
  "module.fieldRequired": "Pflicht",
  "module.fieldPlaceholder": "Placeholder (optional)",
  "module.fieldOptions": "Optionen (kommagetrennt)",
  "module.fieldMultiple": "Mehrfach",

  // --- Module Entries ---
  "moduleEntries.notFound": "Modul nicht gefunden",
  "moduleEntries.noEntries": "Keine Einträge",
  "moduleEntries.editEntry": "Eintrag bearbeiten",
  "moduleEntries.newEntry": "Neuer Eintrag",
  "moduleEntries.titleRequired": "Titel erforderlich",
  "moduleEntries.updated": "Eintrag aktualisiert",
  "moduleEntries.created": "Eintrag erstellt",
  "moduleEntries.deleted": "Eintrag gelöscht",
  "moduleEntries.categoryPlaceholder": "z.B. Standard, Premium",
  "moduleEntries.imageUrl": "Bild URL",
  "moduleEntries.uploadFailed": "Upload fehlgeschlagen",
  "moduleEntries.fileTooLarge": "Datei zu groß (max 20MB)",
  "moduleEntries.notConfigured": "Dieses Modul wurde nicht konfiguriert.",
  "moduleEntries.createFirst": "Erstelle den ersten Eintrag für {name}.",
  "moduleEntries.category": "Kategorie",
  "moduleEntries.publication": "Veröffentlichung",
  "moduleEntries.expiryDate": "Ablaufdatum",
  "moduleEntries.scheduled": "Geplant",
  "moduleEntries.expired": "Abgelaufen",
  "moduleEntries.confirmDelete": "\"{title}\" wirklich löschen?",
  "moduleEntries.documentUrl": "Dokument URL",
  "moduleEntries.autoTranslate": "Automatisch übersetzen",
  "moduleEntries.sourceLanguage": "Quellsprache",
  "moduleEntries.targetLanguage": "Zielsprache",
  "moduleEntries.translate": "Übersetzen",
  "moduleEntries.translating": "Übersetze...",
  "moduleEntries.noTranslatableTexts": "Keine übersetzbaren Texte gefunden",
  "moduleEntries.chooseOtherLanguage": "Bitte eine andere Zielsprache wählen",
  "moduleEntries.textsTranslated": "{count} Texte übersetzt",
  "moduleEntries.translationFailed": "Übersetzung fehlgeschlagen",
  "moduleEntries.translatableFieldsFound": "{count} übersetzbare Textfelder gefunden",

  // --- Media ---
  "media.title": "Medien",
  "media.searchPlaceholder": "Suchen nach Name oder Alt-Text...",
  "media.onlyImages": "Nur Bilder erlaubt",
  "media.fileTooLarge": "Datei zu groß (max 20MB)",
  "media.uploaded": "Bild hochgeladen",
  "media.uploadedMultiple": "Bilder hochgeladen",
  "media.deleted": "Bild gelöscht",
  "media.saved": "Gespeichert",
  "media.folderExists": "Ordner existiert bereits",
  "media.folderCreated": "Ordner \"{name}\" erstellt",
  "media.folderRenamed": "Ordner umbenannt zu \"{name}\"",
  "media.folderDeleted": "Ordner \"{name}\" gelöscht",
  "media.confirmFolderDelete": "Ordner \"{name}\" löschen? {count} Medien werden in \"Alle\" verschoben.",
  "media.confirmDelete": "Wirklich löschen?",
  "media.folderName": "Ordnername",
  "media.all": "Alle",
  "media.noFolder": "Ohne Ordner",
  "media.dropHere": "Bilder hier ablegen",
  "media.newFolder": "Neuer Ordner",
  "media.newSubfolder": "Unterordner",
  "media.deleteFolder": "Ordner löschen",
  "media.move": "Verschieben",
  "media.moved": "{count} Medien verschoben",
  "media.noMediaInFolder": "Keine Medien in \"{folder}\"",
  "media.noMedia": "Noch keine Medien vorhanden",
  "media.uploadToFolder": "Bild in diesen Ordner hochladen",
  "media.uploadFirst": "Erstes Bild hochladen",
  "media.image": "Bild",
  "media.filename": "Dateiname",
  "media.altText": "Alt-Text",
  "media.dimensions": "Abmessungen",
  "media.size": "Größe",
  "media.copyUrl": "URL kopieren",
  "media.fullscreen": "Vollbild",
  "media.editImage": "Bild bearbeiten",
  "media.altTextSeo": "Alt-Text (SEO)",
  "media.altTextPlaceholder": "Beschreibung des Bildes für Suchmaschinen...",
  "media.type": "Typ",
  "media.original": "Original",
  "media.cropRotate": "Zuschneiden / Drehen",
  "media.editImageTitle": "Bild bearbeiten",
  "media.rotate": "Drehen",
  "media.rotateLeft": "Links drehen",
  "media.rotateRight": "Rechts drehen",
  "media.aspect": "Format",
  "media.editHint": "Ziehe die Ecken zum Zuschneiden. Nach dem Speichern werden alle Bildvarianten neu erzeugt und optimiert (max. 600 KB).",
  "media.applyEdit": "Anwenden",
  "media.reoptimize": "Neu optimieren",
  "media.reoptimizeHint": "Ohne Zuschnitt: erzeugt alle Varianten mit aktuellen Einstellungen neu und komprimiert das Bild.",
  "media.editSaved": "Bild bearbeitet",
  "media.reprocessAll": "Alle neu optimieren",
  "media.reprocessAllHint": "Verarbeitet alle Bilder mit den aktuellen Größen/Qualitäten neu und gibt Speicher frei.",
  "media.reprocessAllConfirm": "Alle Bilder neu optimieren? Das kann je nach Anzahl einige Minuten dauern.",
  "media.reprocessDone": "{done} Bilder neu optimiert",
  "media.reprocessDonePartial": "{done} neu optimiert, {failed} fehlgeschlagen",
  "media.reprocessFailed": "Neu-Optimierung fehlgeschlagen",
  "media.reprocessSelectedConfirm": "{count} ausgewählte Bilder neu optimieren?",
  "media.noImagesSelected": "Keine Bilder in der Auswahl",
  "media.replace": "Bild ersetzen",
  "media.replaceHint": "Ersetzt dieses Bild überall, wo es verwendet wird (Seiten, Module, Galerien). Die Adresse bleibt gleich – kein Suchen/Ersetzen nötig.",
  "media.replaceConfirm": "Dieses Bild überall durch das neue ersetzen? Das neue Bild erscheint automatisch auf allen Seiten und in allen Modulen, die es verwenden.",
  "media.replacing": "Wird ersetzt…",
  "media.replaced": "Bild ersetzt – überall aktualisiert",
  "media.typeAll": "Alle",
  "media.typeImages": "Bilder",
  "media.typePdf": "PDF",
  "media.typeDocuments": "Dokumente",

  // --- Chat ---
  "chat.title": "Chat",
  "chat.empty": "Schreibe eine Nachricht um Inhalte zu ändern.",
  "chat.hint": "z.B. \"Ändere den Hero-Titel auf der Startseite\"",
  "chat.placeholder": "Nachricht schreiben...",
  "chat.enterSend": "Enter = Senden, Shift+Enter = Zeilenumbruch",
  "chat.dropImage": "Bild hier ablegen",
  "chat.change": "{n} Änderung",
  "chat.changes": "{n} Änderungen vorgenommen",
  "chat.mediaLibrary": "Medienbibliothek",
  "chat.clickToInsert": "Klicke auf ein Bild um es einzufügen, oder lade ein neues hoch.",
  "chat.noMedia": "Keine Medien vorhanden.",
  "chat.mediaLoadError": "Medien konnten nicht geladen werden",
  "chat.imageUploaded": "Bild hochgeladen",
  "chat.uploadFailed": "Upload fehlgeschlagen. Bitte erneut versuchen.",
  "chat.rateLimitError": "Rate Limit erreicht",
  "chat.quickHero": "Hero Text ändern",
  "chat.quickContact": "Kontaktdaten aktualisieren",
  "chat.quickImage": "Bild ersetzen",

  // --- Users (Kunde) ---
  "users.title": "Benutzer",
  "users.description": "Verwalten Sie die Benutzer für Ihr CMS.",
  "users.newUser": "Neuer Benutzer",
  "users.empty": "Noch keine Benutzer angelegt.",
  "users.namePlaceholder": "Max Mustermann",
  "users.emailPlaceholder": "max@beispiel.de",
  "users.noPermission": "Keine Berechtigung für Benutzerverwaltung",

  // --- Settings (Kunde) ---
  "kundeSettings.title": "Einstellungen",
  "kundeSettings.contactData": "Kontaktdaten",
  "kundeSettings.changePassword": "Passwort ändern",
  "kundeSettings.seoPerPage": "SEO pro Seite",
  "kundeSettings.newPasswordPlaceholder": "Neues Passwort",
  "kundeSettings.minChars": "Mindestens 6 Zeichen",
  "kundeSettings.saved": "Einstellungen gespeichert",
  "kundeSettings.passwordChanged": "Passwort erfolgreich geändert",
  "kundeSettings.seoSaved": "SEO gespeichert",
  "kundeSettings.change": "Ändern",
  "kundeSettings.language": "Sprache",

  // --- Language Switcher ---
  "lang.de": "Deutsch",
  "lang.it": "Italiano",
  "lang.en": "English",
  "lang.label": "Sprache",

  // --- Cookie Fields ---
  "cookie.titleDe": "Titel Deutsch",
  "cookie.titleIt": "Titel Italiano",
  "cookie.titleEn": "Titel English",
  "cookie.textDe": "Text Deutsch",
  "cookie.textIt": "Text Italiano",
  "cookie.textEn": "Text English",
  "cookie.analyticsDe": "Analytics Deutsch",
  "cookie.analyticsIt": "Analytics Italiano",
  "cookie.marketingDe": "Marketing Deutsch",
  "cookie.marketingIt": "Marketing Italiano",
  "cookie.standard": "Standard",

  // --- Custom Fields ---
  "fields.imageUploaded": "Bild hochgeladen",
  "fields.uploadFailed": "Upload fehlgeschlagen",
  "fields.mediaLoadFailed": "Medien laden fehlgeschlagen",
  "fields.noMedia": "Keine Medien vorhanden.",
  "fields.urlPlaceholder": "/uploads/... oder URL eingeben",
  "fields.media": "Medien",
  "fields.selectImage": "Bild auswählen",
  "fields.selectImages": "Bilder auswählen",
  "fields.fromMediaLibrary": "Aus Medienbibliothek",
  "fields.moveForward": "Nach vorne",
  "fields.moveBackward": "Nach hinten",
  "fields.acceptImages": "{count} übernehmen",
  "fields.addButton": "Button hinzufügen",
  "fields.addEntry": "Eintrag hinzufügen",
  "fields.listFields": "Felder pro Eintrag",
  "fields.addCard": "Karte hinzufügen",
  "fields.addFaq": "FAQ hinzufügen",
  "fields.addLogo": "Logo hinzufügen",
  "fields.entryN": "Eintrag {n}",
  "fields.logoN": "Logo {n}",
  "fields.yes": "Ja",
  "fields.no": "Nein",
  "fields.dateFrom": "Von",
  "fields.dateTo": "Bis",
  "fields.pleaseSelect": "Bitte wählen...",
  "fields.bold": "Fett",
  "fields.italic": "Kursiv",
  "fields.bulletList": "Aufzählung",
  "fields.numberedList": "Nummerierte Liste",
  "fields.link": "Link",
  "fields.removeLink": "Link entfernen",
  "fields.enterUrl": "URL eingeben:",
  "fields.clickToRename": "Klicken zum Umbenennen",
  "fields.duplicateField": "Feld duplizieren",
  "fields.removeField": "Feld entfernen",
  "fields.videoPlaceholder": "https://youtube.com/watch?v=... oder https://vimeo.com/...",
  "fields.style": "Stil",
  "fields.buttonSize": "Größe",
  "fields.small": "Klein",
  "fields.medium": "Mittel",
  "fields.large": "Groß",
  "fields.iconLucide": "Icon (Lucide Name)",
  "fields.optional": "(optional)",
  "fields.description": "Beschreibung",
  "fields.imageOptional": "Bild (optional)",
  "fields.insertImage": "Bild einfügen",
  "fields.companyName": "Firmenname",
  "fields.internalPage": "Interne Seite",
  "fields.externalUrl": "Externe URL",
  "fields.selectPage": "Seite auswählen...",
  "fields.searchPage": "Seite suchen...",
  "fields.noPagesFound": "Keine Seiten gefunden",

  // --- SEO Tool (Vorschau, Checkliste, KI, Redirects, Alt-Texte) ---
  "pages.serpPreview": "Google-Vorschau",
  "pages.serpDesktop": "Desktop",
  "pages.serpMobile": "Mobil",
  "pages.serpFallbackTitle": "Seitentitel wird verwendet",
  "pages.serpFallbackDesc": "Keine Meta Description – Google zeigt einen Textausschnitt der Seite.",
  "pages.socialPreview": "Vorschau beim Teilen",
  "pages.socialNoImage": "Kein Vorschaubild",
  "pages.fokusKeyword": "Fokus-Keyword",
  "pages.fokusKeywordPlaceholder": "z.B. Ferienwohnung Meran",
  "pages.fokusKeywordHint": "Der Suchbegriff, für den diese Seite ranken soll. Wird in Title, Description, Überschrift, URL und Text geprüft.",
  "pages.seoChecklist": "SEO-Check",
  "pages.seoScore": "{ok} von {total} erfüllt",
  "pages.pixelWidth": "{px} px",
  "pages.aiSuggest": "Vorschlagen",
  "pages.aiSuggestTitleHint": "3 Vorschläge per KI aus dem Seiteninhalt",
  "pages.aiSuggestions": "KI-Vorschläge",
  "pages.aiSuggestLoading": "Vorschläge werden erstellt…",
  "pages.aiSuggestFailed": "Vorschlag fehlgeschlagen",
  "pages.aiSuggestNoText": "Die Seite hat noch keinen Text. Bitte zuerst Inhalte anlegen.",
  "pages.apply": "Übernehmen",
  "pages.noIndexTitle": "Diese Seite nicht indexieren",
  "pages.noIndexHint": "Setzt robots: noindex, nofollow nur für diese Seite. Nützlich für Danke-/Testseiten oder Inhalte, die nicht bei Google erscheinen sollen.",
  "pages.redirectTitle": "Weiterleitung anlegen?",
  "pages.redirectHint": "Die URL dieser Seite hat sich geändert. Damit alte Links und Google-Einträge weiter funktionieren, sollte eine 301-Weiterleitung angelegt werden.",
  "pages.redirectCreate": "Weiterleitung anlegen",
  "pages.redirectSkip": "Nicht jetzt",
  "pages.redirectCreated": "{n} Weiterleitung(en) angelegt",
  "pages.redirectFailed": "Weiterleitung konnte nicht angelegt werden",
  "seoCheck.titleMissing": "Kein Meta Title – der Seitentitel wird verwendet",
  "seoCheck.titleLong": "Meta Title zu lang ({px} px) – wird in Google abgeschnitten",
  "seoCheck.titleShort": "Meta Title sehr kurz – mehr Kontext nutzen",
  "seoCheck.titleOk": "Meta Title hat eine gute Länge",
  "seoCheck.descMissing": "Meta Description fehlt",
  "seoCheck.descLong": "Meta Description zu lang ({n} Zeichen)",
  "seoCheck.descShort": "Meta Description sehr kurz ({n} Zeichen)",
  "seoCheck.descOk": "Meta Description hat eine gute Länge",
  "seoCheck.h1Missing": "Keine Überschrift (H1) – Hero- oder Sektionstitel setzen",
  "seoCheck.h1Ok": "Überschrift (H1) vorhanden",
  "seoCheck.textThin": "Wenig Text ({n} Wörter) – mindestens 300 empfohlen",
  "seoCheck.textMedium": "{n} Wörter – für wichtige Seiten mehr Text",
  "seoCheck.textOk": "Ausreichend Text ({n} Wörter)",
  "seoCheck.linksNone": "Keine internen Links – auf andere Seiten verlinken",
  "seoCheck.linksOk": "{n} interne Links",
  "seoCheck.imagesNone": "Keine Bilder auf der Seite",
  "seoCheck.imagesCount": "{n} Bilder auf der Seite",
  "seoCheck.imagesAltMissing": "{n} von {total} Bildern ohne Alt-Text (Mediathek)",
  "seoCheck.imagesOk": "Alle {n} Bilder haben einen Alt-Text",
  "seoCheck.slugLong": "URL sehr lang – kürzeren Slug wählen",
  "seoCheck.keywordNone": "Kein Fokus-Keyword gesetzt",
  "seoCheck.keywordTitle": "Keyword im Meta Title",
  "seoCheck.keywordDesc": "Keyword in der Meta Description",
  "seoCheck.keywordH1": "Keyword in der Überschrift",
  "seoCheck.keywordSlug": "Keyword in der URL",
  "seoCheck.keywordIntro": "Keyword im ersten Textabschnitt",
  "seoCheck.keywordBodyNone": "Keyword kommt im Text nicht vor",
  "seoCheck.keywordStuffing": "Keyword sehr häufig ({n}×) – wirkt unnatürlich",
  "seoCheck.keywordBody": "Keyword im Text ({n}×)",
  "seoCheck.noIndex": "Seite ist von der Indexierung ausgeschlossen",
  "media.altGenerate": "Per KI vorschlagen",
  "media.altGenerating": "Wird erstellt…",
  "media.altGenerated": "Alt-Text vorgeschlagen",
  "media.altGenerateFailed": "Alt-Text konnte nicht erstellt werden",
  "media.altGenerateAll": "Fehlende Alt-Texte per KI",
  "media.altGenerateAllConfirm": "{n} Bilder ohne Alt-Text per KI beschreiben lassen? Das kann einige Minuten dauern.",
  "media.altGenerateDone": "{done} Alt-Texte erstellt",
  "media.altGenerateDonePartial": "{done} Alt-Texte erstellt, {failed} fehlgeschlagen",
  "media.altGenerateNone": "Alle Bilder haben bereits einen Alt-Text",
  "media.altFilterMissing": "Ohne Alt-Text",
  // --- Partnerseiten ---
  "kundeSidebar.partner": "Partnerseiten",
  "partner.title": "Partnerseiten",
  "partner.new": "Neuer Partner",
  "partner.create": "Anlegen",
  "partner.created": "Partner angelegt",
  "partner.deleted": "Partner gelöscht",
  "partner.saved": "Partner gespeichert",
  "partner.empty": "Noch keine Partner angelegt",
  "partner.emptyHint": "Lege einen Partner an, um seine Seite im eigenen Design zu erstellen.",
  "partner.confirmDelete": "Partner „{name}“ wirklich löschen? Die Partnerseite ist danach nicht mehr erreichbar.",
  "partner.nameRequired": "Bitte einen Namen eingeben",
  "partner.slugInvalid": "Ungültige Adresse (nur a–z, 0–9 und Bindestriche)",
  "partner.moduleInactive": "Das Modul Partnerseiten ist für diesen Kunden nicht freigeschaltet.",
  "partner.statusActive": "Aktiv",
  "partner.statusDraft": "Entwurf",
  "partner.openWebsite": "Auf der Website ansehen",
  "partner.preview": "Vorschau",
  "partner.loadError": "Partner konnte nicht geladen werden",
  "partner.backToList": "Alle Partner",
  "partner.mainLanguage": "Haupt",
  "partner.col.name": "Partner",
  "partner.col.url": "Adresse",
  "partner.col.brand": "Brand-ID",
  "partner.col.status": "Status",
  "partner.tab.allgemein": "Allgemein",
  "partner.tab.branding": "Branding",
  "partner.tab.kontakt": "Kontakt",
  "partner.tab.inhalte": "Inhalte",
  "partner.tab.angebote": "Angebote",
  "partner.tab.zusatz": "Zusatzbereiche",
  "partner.field.name": "Name",
  "partner.field.slug": "Adresse",
  "partner.field.brandId": "TravelSeller Brand-ID",
  "partner.field.partnerId": "TravelSeller Partner-ID (optional)",
  "partner.field.aktiv": "Partnerseite aktiv (öffentlich erreichbar)",
  "partner.field.logo": "Logo",
  "partner.field.favicon": "Favicon",
  "partner.field.primary": "Primärfarbe",
  "partner.field.secondary": "Sekundärfarbe",
  "partner.field.accent": "Akzentfarbe",
  "partner.field.font": "Schrift (Google Fonts)",
  "partner.field.telefon": "Telefon",
  "partner.field.email": "E-Mail",
  "partner.field.website": "Website des Partners",
  "partner.field.adresse": "Adresse",
  "partner.field.heroTitel": "Banner – Titel",
  "partner.field.heroUntertitel": "Banner – Untertitel",
  "partner.field.heroBild": "Banner – Bild",
  "partner.field.einleitungTitel": "Einleitung – Titel",
  "partner.field.einleitungText": "Einleitung – Text",
  "partner.field.galerie": "Bildergalerie",
  "partner.field.vorteile": "Vorteile",
  "partner.field.faq": "Häufige Fragen",
  "partner.slugHint": "Kleinbuchstaben, Ziffern und Bindestriche. Eine Änderung macht alte Links ungültig.",
  "partner.brandIdHint": "Wird bei TravelSeller für den Partner angelegt. Pflicht vor dem Aktivieren.",
  "partner.partnerIdHint": "Nur nötig, wenn TravelSeller einen Vermittler zur Zuordnung der Buchungen verlangt.",
  "partner.aktivHint": "Inaktive Partner sind nur über den Vorschau-Link erreichbar.",
  "partner.missingTitle": "Vor dem Aktivieren fehlt noch:",
  "partner.previewLink": "Vorschau-Link",
  "partner.previewRenew": "Neuen Link erzeugen",
  "partner.previewHint": "Wer den Link kennt, sieht die Seite vor dem Aktivieren. Ein neuer Link macht den alten ungültig.",
  "partner.contrastWarning": "Weiße Schrift auf der Primärfarbe ist schwer lesbar (Kontrast {ratio}:1, empfohlen mindestens 4,5:1). Eine dunklere Farbe wählen.",
  "partner.fontHint": "Leer lassen, um die Schrift der Website zu verwenden.",
  "partner.filterIntro": "Diese Angebote erscheinen auf der Partnerseite. Neue Angebote in TravelSeller, die passen, kommen automatisch dazu. Mehrere Werte mit Komma trennen.",
  "partner.filter.zielorte": "Zielorte / Regionen",
  "partner.filter.zielorteHint": "Namen wie in TravelSeller (deutsch), z. B. Meran und Umgebung, Skigebiet Kronplatz",
  "partner.filter.themen": "Themen",
  "partner.filter.themenHint": "Themen-Titel wie in TravelSeller (deutsch), z. B. Wellness, Familie",
  "partner.filter.abflughafen": "Abflughafen (vorausgewählt)",
  "partner.filter.abflughafenHint": "IATA-Code, z. B. DUS. Leer = Gast wählt selbst.",
  "partner.filter.verpflegung": "Verpflegung",
  "partner.filter.verpflegungHint": "TravelSeller-Verpflegungs-IDs, z. B. 2, 3",
  "partner.filter.angeboteEin": "Zusätzlich zeigen (Angebots-IDs)",
  "partner.filter.angeboteEinHint": "TravelSeller-IDs, die unabhängig vom Filter erscheinen",
  "partner.filter.angeboteAus": "Ausschließen (Angebots-IDs)",
  "partner.filter.angeboteAusHint": "TravelSeller-IDs, die nie erscheinen",
  "partner.platz.nachEinleitung": "Nach der Einleitung",
  "partner.platz.nachAngeboten": "Nach den Angeboten",
  "partner.platz.vorKontakt": "Vor dem Kontakt",
  "partner.zusatzEmpty": "Hier ist noch kein Zusatzbereich.",
  "partner.zusatzPlatz": "Position",
  "partner.moveUp": "Nach oben",
  "partner.moveDown": "Nach unten",
  "partner.zusatzConfirmRemove": "Zusatzbereich „{name}“ entfernen?",
  "partner.zusatzAdd": "Zusatzbereich hinzufügen",
  "partner.zusatzTyp": "Art",
  "partner.zusatzLabel": "Bezeichnung (nur im CMS)",
  "partner.zusatzAddButton": "Hinzufügen",
  "partner.missing.slug": "gültige Adresse",
  "partner.missing.name": "Name",
  "partner.missing.brandId": "TravelSeller Brand-ID",
  "partner.missing.logo": "Logo",
  "partner.missing.primary": "Primärfarbe",
  "partner.missing.heroTitel": "Banner-Titel (Hauptsprache)",
  "partner.adminToggleTitle": "Partnerseiten",
  "partner.adminToggleHint": "Schaltet den Bereich „Partnerseiten“ im CMS dieses Kunden frei. Wird sofort gespeichert.",
  "partner.adminEnabled": "Partnerseiten freigeschaltet",
  "partner.adminDisabled": "Partnerseiten deaktiviert",
  "partner.translate": "Übersetzen",
  "partner.translateTitle": "Inhalte automatisch übersetzen",
  "partner.translateIntro": "Übersetzt Inhalte, Adresse und Zusatzbereiche aus der Hauptsprache ({sprache}).",
  "partner.translateTargets": "Zielsprachen",
  "partner.translateMode": "Was übersetzen?",
  "partner.translateOnlyEmpty": "Nur leere Felder",
  "partner.translateOverwrite": "Alles neu übersetzen (überschreibt bestehende Übersetzungen)",
  "partner.translateHint": "Die Übersetzung landet im Editor. Bitte prüfen und dann speichern.",
  "partner.translateStart": "Übersetzen",
  "partner.translateRunning": "Übersetze …",
  "partner.translateDone": "{anzahl} Texte übersetzt – bitte prüfen und speichern",
  "partner.translatePartial": "{anzahl} Texte übersetzt, {fehlend} nicht – bitte prüfen und erneut versuchen",
  "partner.translateNothing": "Nichts zu übersetzen – alle Felder haben bereits Text",
  "partner.translateNoSource": "In der Hauptsprache ist noch kein Text vorhanden",
  "partner.translateError": "Übersetzung fehlgeschlagen",
  "partner.field.heroButtons": "Banner – Buttons",
  "partner.field.kennzahlen": "Kennzahlen unter dem Banner (Titel = Zahl, Text = Bezeichnung)",
  "partner.field.schritteTitel": "„So funktioniert's“ – Überschrift",
  "partner.field.schritte": "„So funktioniert's“ – Schritte",
  "partner.field.kontaktTitel": "Kontakt-Band – Titel",
  "partner.field.kontaktText": "Kontakt-Band – Text",
  "partner.platz.nachBanner": "Nach dem Banner",
};

export default de;
